var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: "32px",
    height: "32px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 16 28.15625 L 15.5 27.863281 C 14.988281 27.570313 3 20.53125 3 13 C 3 9.140625 6.140625 6 10 6 C 12.542969 6 14.773438 7.363281 16 9.398438 C 17.226563 7.363281 19.457031 6 22 6 C 25.859375 6 29 9.140625 29 13 C 29 20.53125 17.011719 27.570313 16.5 27.863281 Z M 10 8 C 7.242188 8 5 10.242188 5 13 C 5 18.605469 13.785156 24.445313 16 25.828125 C 18.214844 24.445313 27 18.605469 27 13 C 27 10.242188 24.757813 8 22 8 C 19.242188 8 17 10.242188 17 13 L 15 13 C 15 10.242188 12.757813 8 10 8 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.84cb924c63cab03e9244308bc15e9c61.svg";
export { ForwardRef as ReactComponent };